export default __webpack_public_path__ + "static/media/warehouse.0f533b16.png";